require("common");
require("components/parallax-content");
require("clients")

var arrayBackground = [
    "/wp-content/themes/osiris/public/images/01_home.jpg", 
    "/wp-content/themes/osiris/public/images/02_home.jpg", 
    "/wp-content/themes/osiris/public/images/03_home.jpg"
];

$('.top.navigation').css('backgroundImage', 'url('+ arrayBackground[Math.floor(Math.random()*3)] +')');